export default "__VITE_ASSET__kYqD1Lb8__"